import { ErrorResponse, ServerError } from '~/infra/ErrorResponse';
export const isDuplicateNameError = (error)=>new ErrorResponse(error).hasServerError(ServerError.CustomPageTemplateDuplicateName);
export const extractExistingTemplateId = (error)=>{
    const errorResponse = new ErrorResponse(error);
    if (!errorResponse.hasServerError(ServerError.CustomPageTemplateDuplicateName)) return undefined;
    return errorResponse.getExistingTemplateId();
};
